import axios from 'axios';

const api = axios.create({
  baseURL: process?.env?.NEXT_PUBLIC_BASE_URL_PRD || 'https://locare-api.azurewebsites.net/api',
  //baseURL: 'https://locare-api.azurewebsites.net/api',
});

export default api;
